export const convocatoria001 = [
  {
    nombre: "CONVOCATORIA 01-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/CONVOCATORIA 01-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n1 = [
  {
    nombre: "BASES EA-913005999-N1-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N1/BASES EA-913005999-N1-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-91300599-N1-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N1/JUNTA DE ACLARACIONES EA-91300599-N1-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE APERTURA EA-913005999-N1-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N1/ACTA DE APERTURA EA-913005999-N1-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE FALLO N1-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N1/ACTA DE FALLO N1-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n2 = [
  {
    nombre: "BASES EA-913005999-N2-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N2/BASES EA-913005999-N2-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-91300599-N2-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N2/JUNTA DE ACLARACIONES EA-91300599-N2-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE APERTURA EA-913005999-N2-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N2/ACTA DE APERTURA EA-913005999-N2-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n3 = [
  {
    nombre: "BASES EA-913005999-N3-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N3/BASES EA-913005999-N3-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-91300599-N3-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N3/JUNTA DE ACLARACIONES EA-91300599-N3-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE APERTURA EA-913005999-N3-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N3/ACTA DE APERTURA EA-913005999-N3-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE FALLO N3-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N3/ACTA DE FALLO N3-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n4 = [
  {
    nombre: "BASES EA-913005999-N4-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N4/BASES EA-913005999-N4-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-91300599-N4-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N4/JUNTA DE ACLARACIONES EA-91300599-N4-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE APERTURA EA-913005999-N4-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N4/ACTA DE APERTURA EA-913005999-N4-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE FALLO N4-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N4/ACTA DE FALLO N4-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n5 = [
  {
    nombre: "BASES EA-913005999-N5-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N5/BASES EA-913005999-N5-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-91300599-N5-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N5/JUNTA DE ACLARACIONES EA-91300599-N5-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE APERTURA EA-913005999-N5-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N5/ACTA DE APERTURA EA-913005999-N5-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE FALLO N5-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N5/ACTA DE FALLO N5-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoria002 = [
  {
    nombre: "CONVOCATORIA 02-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 02-2026/CONVOCATORIA 02-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n6 = [
  {
    nombre: "BASES EA-913005999-N6-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 02-2026/N6/BASES EA-913005999-N6-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N6-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 02-2026/N6/JUNTA DE ACLARACIONES EA-913005999-N6-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N6-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 02-2026/N6/PRESENTACION Y APERTURA EA-913005999-N6-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N6-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 02-2026/N6/FALLO EA-913005999-N6-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n7 = [
  {
    nombre: "BASES EA-913005999-N7-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 02-2026/N7/BASES EA-913005999-N7-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N7-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 02-2026/N7/JUNTA DE ACLARACIONES EA-913005999-N7-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N7-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 02-2026/N7/PRESENTACION Y APERTURA EA-913005999-N7-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N7-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 02-2026/N7/FALLO EA-913005999-N7-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const convocatoria003 = [
  {
    nombre: "CONVOCATORIA 03-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/CONVOCATORIA 03-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n8 = [
  {
    nombre: "EA-913005999-N8-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N8/EA-913005999-N8-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N8-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N8/JUNTA DE ACLARACIONES EA-913005999-N8-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA APERTURA EA-913005999-N8-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N8/ACTA APERTURA EA-913005999-N8-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N8-2026.pdf",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N8/FALLO EA-913005999-N8-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n9 = [
  {
    nombre: "EA-913005999-N9-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N9/EA-913005999-N9-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N9-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N9/JUNTA DE ACLARACIONES EA-913005999-N9-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "ACTA APERTURA EA-913005999-N9-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N9/ACTA APERTURA EA-913005999-N9-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N9-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N9/FALLO EA-913005999-N9-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n10 = [
  {
    nombre: "EA-913005999-N10-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N10/EA-913005999-N10-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N10-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N10/JUNTA DE ACLARACIONES EA-913005999-N10-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA APERTURA EA-913005999-N10-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N10/ACTA APERTURA EA-913005999-N10-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N10-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N10/FALLO EA-913005999-N10-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const convocatoria004 = [
  {
    nombre: "CONVOCATORIA 04-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/CONVOCATORIA 04-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n11 = [
  {
    nombre: "EA-913005999-N11-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N11/EA-913005999-N11-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N11-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N11/JUNTA DE ACLARACIONES EA-913005999-N11-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA APERTURA EA-913005999-N11-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N11/ACTA APERTURA EA-913005999-N11-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N11-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N11/FALLO EA-913005999-N11-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n12 = [
  {
    nombre: "EA-913005999-N12-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N12/EA-913005999-N12-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N12-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N12/JUNTA DE ACLARACIONES EA-913005999-N12-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA APERTURA EA-913005999-N12-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N12/ACTA APERTURA EA-913005999-N12-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N12-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N12/FALLO EA-913005999-N12-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n13 = [
  {
    nombre: "EA-913005999-N13-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N13/EA-913005999-N13-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N13-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N13/JUNTA DE ACLARACIONES EA-913005999-N13-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA APERTURA EA-913005999-N13-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N13/ACTA APERTURA EA-913005999-N13-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N13-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N13/FALLO EA-913005999-N13-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n14 = [
  {
    nombre: "EA-913005999-N14-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N14/EA-913005999-N14-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N14-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N14/JUNTA DE ACLARACIONES EA-913005999-N14-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA APERTURA EA-913005999-N14-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N14/ACTA APERTURA EA-913005999-N14-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N14-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N14/FALLO EA-913005999-N14-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n15 = [
  {
    nombre: "EA-913005999-N15-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N15/EA-913005999-N15-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N15-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N15/JUNTA DE ACLARACIONES EA-913005999-N15-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA APERTURA EA-913005999-N15-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N15/ACTA APERTURA EA-913005999-N15-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N15-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N15/FALLO EA-913005999-N15-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const convocatoria005 = [
  {
    nombre: "CONVOCATORIA 05-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 05-2026/CONVOCATORIA 05-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n16 = [
  {
    nombre: "EA-913005999-N16-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 05-2026/N16/EA-913005999-N16-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N16-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 05-2026/N16/JUNTA DE ACLARACIONES EA-913005999-N16-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA APERTURA EA-913005999-N16-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 05-2026/N16/ACTA APERTURA EA-913005999-N16-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N16-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 05-2026/N16/FALLO EA-913005999-N16-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n17 = [
  {
    nombre: "EA-913005999-N17-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 05-2026/N17/EA-913005999-N17-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N17-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 05-2026/N17/JUNTA DE ACLARACIONES EA-913005999-N17-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA APERTURA EA-913005999-N17-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 05-2026/N17/ACTA APERTURA EA-913005999-N17-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N17-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 05-2026/N17/FALLO EA-913005999-N17-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const convocatoria006 = [
  {
    nombre: "CONVOCATORIA 06-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/CONVOCATORIA 06-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n18 = [
  {
    nombre: "EA-913005999-N18-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N18/EA-913005999-N18-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N18-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N18/JUNTA DE ACLARACIONES EA-913005999-N18-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "APERTURA DE PROPOSICIONES  EA-913005999-N18-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N18/APERTURA DE PROPOSICIONES  EA-913005999-N18-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  /* {
    nombre: "ACTA APERTURA EA-913005999-N18-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N18/ACTA APERTURA EA-913005999-N18-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  }, */
  {
    nombre: "FALLO EA-913005999-N18-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N18/FALLO EA-913005999-N18-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n19 = [
  {
    nombre: "EA-913005999-N19-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N19/EA-913005999-N19-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N19-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N19/JUNTA DE ACLARACIONES EA-913005999-N19-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "APERTURA DE PROPOSICIONES  EA-913005999-N19-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N19/APERTURA DE PROPOSICIONES  EA-913005999-N19-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  /* {
    nombre: "ACTA APERTURA EA-913005999-N19-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N19/ACTA APERTURA EA-913005999-N19-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  }, */
  {
    nombre: "FALLO EA-913005999-N19-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N19/FALLO EA-913005999-N19-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n20 = [
  {
    nombre: "EA-913005999-N20-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N20/EA-913005999-N20-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N20-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N20/JUNTA DE ACLARACIONES EA-913005999-N20-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "APERTURA DE PROPOSICIONES EA-913005999-N20-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N20/APERTURA DE PROPOSICIONES EA-913005999-N20-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  /* {
    nombre: "ACTA APERTURA EA-913005999-N20-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N20/ACTA APERTURA EA-913005999-N20-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  }, */
  {
    nombre: "FALLO EA-913005999-N20-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N20/FALLO  EA-913005999-N20-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n21 = [
  {
    nombre: "EA-913005999-N21-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/EA-913005999-N21-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA DE PROPOSICIONES  EA-913005999-N21-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/APERTURA DE PROPOSICIONES  EA-913005999-N21-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "PARTIDA 1 RECIBO DE AGUA ANVERSO",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 1 RECIBO DE AGUA ANVERSO.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 1 RECIBO DE AGUA  REVERSO TEMPORADA DE LLUVIAS",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 1 RECIBO DE AGUA  REVERSO TEMPORADA DE LLUVIAS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 2 FORMATO DE  SELLO ADHERIBLE DE RESTRINGIDO",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 2 FORMATO DE  SELLO ADHERIBLE DE RESTRINGIDO.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 3 FORMATO DE  SELLO ADHERIBLE DE SUSPENDIDO",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 3 FORMATO DE  SELLO ADHERIBLE DE SUSPENDIDO.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 4 INFORME DE INSTALACIÓN O SUSTITUCIÓN",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 4 INFORME DE INSTALACIÓN O SUSTITUCIÓN.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 5 FORMATO DE CONTRATO DE PRESTACION DE SERVICIOS TEMPORAL",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 5 FORMATO DE CONTRATO DE PRESTACION DE SERVICIOS TEMPORAL.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 6 FORMATO DE CONTRATO DE PRESTACION DE SERVICIOS",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 6 FORMATO DE CONTRATO DE PRESTACION DE SERVICIOS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 7 FORMATO DE INFORME DE SUPERVISIÓN Y VERIFICACIÓN",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 7 FORMATO DE INFORME DE SUPERVISIÓN Y VERIFICACIÓN.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 8 FORMATO DE ACTA CIRCUNTANCIADA",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 8 FORMATO DE ACTA CIRCUNTANCIADA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 9 FORMATO DE SOLICITUD DE CAMBIO AL PADRÓN DE USUARIOS",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 9 FORMATO DE SOLICITUD DE CAMBIO AL PADRÓN DE USUARIOS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 10  CALCOMANIA DE VERIFICACIÓN",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 10  CALCOMANIA DE VERIFICACIÓN.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 11  CALCOMANIA DE VERIFICACIÓN",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 11  CALCOMANIA DE VERIFICACIÓN.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 12  CALCOMANIA DE VERIFICACIÓN",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 12  CALCOMANIA DE VERIFICACIÓN.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 13  CALCOMANIA DE VERIFICACIÓN",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 13  CALCOMANIA DE VERIFICACIÓN.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 14  FORMATO REPORTE DE USUARIO",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 14  FORMATO REPORTE DE USUARIO.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 15 FORMATO VERIFICACIOIN PIPAS AGUA POTABLE",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 15 FORMATO VERIFICACIOIN PIPAS AGUA POTABLE.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 16  FORMATO PARA MONITOREO DE CLORO",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 16  FORMATO PARA MONITOREO DE CLORO.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 17 FORMATO DE ACTA CIRCUNSTANCIADA",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 17 FORMATO DE ACTA CIRCUNSTANCIADA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PARTIDA 18 FORMATO DE AUTORIZACIÓN DE CARGOS PARA TRÁMITES DE SANEAMIENTO",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 18 FORMATO DE AUTORIZACIÓN DE CARGOS PARA TRÁMITES DE SANEAMIENTO.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PARTIDA 19 FORMATO DE SOLICITUD DE ANÁLISIS DE LABORATORIO DE AGUA RESIDUAL",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 19 FORMATO DE SOLICITUD DE ANÁLISIS DE LABORATORIO DE AGUA RESIDUAL.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 20 FORMATO DE SOLICITUD DE  REPOSICIÓN  DE REPOSICIÓN",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 20 FORMATO DE SOLICITUD DE  REPOSICIÓN  DE REPOSICIÓN.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PARTIDA 21 FORMATO DE SOLICITUD DE RENOVACIÓN DE PERMISO DE DESCARGA DE AGUA RESIDUAL",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 21 FORMATO DE SOLICITUD DE RENOVACIÓN DE PERMISO DE DESCARGA DE AGUA RESIDUAL.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PARTIDA 22 FORMATO DE SOLICITUD DE PERMISO DE DESCARGA DE AGUA RESIDUAL",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 22 FORMATO DE SOLICITUD DE PERMISO DE DESCARGA DE AGUA RESIDUAL.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 23 FORMATO DE PRIMER CITATORIO",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 23 FORMATO DE PRIMER CITATORIO.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 24 FORMATO DE SEGUNDO CITATORIO",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 24 FORMATO DE SEGUNDO CITATORIO.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 25 CORTE DE CAJA",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/PARTIDA 25 CORTE DE CAJA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N21-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/JUNTA DE ACLARACIONES EA-913005999-N21-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  /* {
    nombre: "ACTA APERTURA EA-913005999-N21-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/ACTA APERTURA EA-913005999-N21-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  }, */
  {
    nombre: "FALLO EA-913005999-N21-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 06-2026/N21/FALLO EA-913005999-N21-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const convocatoriaObra01 = [
  {
    nombre: "CONVOCATORIA MULTIPLE 01-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA MULTIPLE 01-2026/CONVOCATORIA MULTIPLE 01-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const lop1 = [
  {
    nombre: "BASES CAASIM-HGO-L.O.P.-01-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA MULTIPLE 01-2026/CAASIM-HGO-L.O.P.-01-2026/BASES CAASIM-HGO-L.O.P.-01-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-L.O.P.-01-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA MULTIPLE 01-2026/CAASIM-HGO-L.O.P.-01-2026/CATALOGO MUDO CAASIM-HGO-L.O.P.-01-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-01-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA MULTIPLE 01-2026/CAASIM-HGO-L.O.P.-01-2026/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-01-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-01-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA MULTIPLE 01-2026/CAASIM-HGO-L.O.P.-01-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-01-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO CAASIM-HGO-L.O.P.-01-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA MULTIPLE 01-2026/CAASIM-HGO-L.O.P.-01-2026/FALLO CAASIM-HGO-L.O.P.-01-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const lop2 = [
  {
    nombre: "BASES CAASIM-HGO-L.O.P.-02-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA MULTIPLE 01-2026/CAASIM-HGO-L.O.P.-02-2026/BASES CAASIM-L.O.P.-02-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-L.O.P.-02-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA MULTIPLE 01-2026/CAASIM-HGO-L.O.P.-02-2026/CATALOGO MUDO CAASIM-HGO-L.O.P.-02-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PLANO CAASIM-HGO-L.O.P.-02-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA MULTIPLE 01-2026/CAASIM-HGO-L.O.P.-02-2026/PLANO CAASIM-HGO-L.O.P.-02-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-02-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA MULTIPLE 01-2026/CAASIM-HGO-L.O.P.-02-2026/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-02-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-02-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA MULTIPLE 01-2026/CAASIM-HGO-L.O.P.-02-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-02-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO CAASIM-HGO-L.O.P.-02-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA MULTIPLE 01-2026/CAASIM-HGO-L.O.P.-02-2026/FALLO CAASIM-HGO-L.O.P.-02-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const lop3 = [
  {
    nombre: "BASES CAASIM-HGO-L.O.P.-03-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA MULTIPLE 01-2026/CAASIM-HGO-L.O.P.-03-2026/BASES CAASIM-HGO-L.O.P.-03-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-L.O.P.-03-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA MULTIPLE 01-2026/CAASIM-HGO-L.O.P.-03-2026/CATALOGO MUDO CAASIM-HGO-L.O.P.-03-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-03-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA MULTIPLE 01-2026/CAASIM-HGO-L.O.P.-03-2026/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-03-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-03-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA MULTIPLE 01-2026/CAASIM-HGO-L.O.P.-03-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-03-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO CAASIM-HGO-L.O.P.-03-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA MULTIPLE 01-2026/CAASIM-HGO-L.O.P.-03-2026/FALLO CAASIM-HGO-L.O.P.-03-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const convocatoria007 = [
  {
    nombre: "CONVOCATORIA 07-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/CONVOCATORIA 07-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n22 = [
  {
    nombre: "BASES EA-913005999-N22-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N22/BASES EA-913005999-N22-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N22-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N22/JUNTA DE ACLARACIONES EA-913005999-N22-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "APERTURA DE PROPOSICIONES EA-913005999-N22-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N22/APERTURA DE PROPOSICIONES  EA-913005999-N22-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  // /* {
  //   nombre: "ACTA APERTURA EA-913005999-N22-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N20/ACTA APERTURA EA-913005999-N22-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // }, */
  {
    nombre: "FALLO EA-913005999-N22-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N22/FALLO EA-913005999-N22-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n23 = [
  {
    nombre: "BASES EA-913005999-N23-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N23/BASES EA-913005999-N23-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N23-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N23/JUNTA DE ACLARACIONES EA-913005999-N23-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "APERTURA DE PROPOSICIONES EA-913005999-N23-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N23/APERTURA DE PROPOSICIONES  EA-913005999-N23-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  // /* {
  //   nombre: "ACTA APERTURA EA-913005999-N23-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N23/ACTA APERTURA EA-913005999-N23-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // }, */
  {
    nombre: "FALLO EA-913005999-N23-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N23/FALLO EA-913005999-N23-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n24 = [
  {
    nombre: "BASES EA-913005999-N24-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N24/BASES EA-913005999-N24-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N24-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N24/JUNTA DE ACLARACIONES EA-913005999-N24-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "APERTURA DE PROPOSICIONES EA-913005999-N24-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N24/APERTURA DE PROPOSICIONES  EA-913005999-N24-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  // /* {
  //   nombre: "ACTA APERTURA EA-913005999-N24-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N24/ACTA APERTURA EA-913005999-N24-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // }, */
  {
    nombre: "FALLO EA-913005999-N24-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N24/FALLO EA-913005999-N24-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n25 = [
  {
    nombre: "BASES EA-913005999-N25-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N25/BASES EA-913005999-N25-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N25-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N25/JUNTA DE ACLARACIONES EA-913005999-N25-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "APERTURA DE PROPOSICIONES EA-913005999-N25-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N25/APERTURA DE PROPOSICIONES EA-913005999-N25-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  // /* {
  //   nombre: "ACTA APERTURA EA-913005999-N25-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N25/ACTA APERTURA EA-913005999-N25-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // }, */
  {
    nombre: "FALLO EA-913005999-N25-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N25/FALLO EA-913005999-N25-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n26 = [
  {
    nombre: "BASES EA-913005999-N26-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N26/BASES EA-913005999-N26-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N26-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N26/JUNTA DE ACLARACIONES EA-913005999-N26-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "APERTURA DE PROPOSICIONES EA-913005999-N26-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N26/APERTURA DE PROPOSICIONES  EA-913005999-N26-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  // /* {
  //   nombre: "ACTA APERTURA EA-913005999-N26-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N26/ACTA APERTURA EA-913005999-N26-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // }, */
  {
    nombre: "FALLO EA-913005999-N26-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N26/FALLO EA-913005999-N26-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n27 = [
  {
    nombre: "BASES EA-913005999-N27-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N27/BASES EA-913005999-N27-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N27-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N27/JUNTA DE ACLARACIONES EA-913005999-N27-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "APERTURA DE PROPOSICIONES EA-913005999-N27-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N27/APERTURA DE PROPOSICIONES  EA-913005999-N27-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  // /* {
  //   nombre: "ACTA APERTURA EA-913005999-N27-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N27/ACTA APERTURA EA-913005999-N27-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // }, */
  {
    nombre: "FALLO EA-913005999-N27-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N27/FALLO EA-913005999-N27-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n28 = [
  {
    nombre: "BASES EA-913005999-N28-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N28/BASES EA-913005999-N28-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N28-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N28/JUNTA DE ACLARACIONES EA-913005999-N28-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "APERTURA DE PROPOSICIONES EA-913005999-N28-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N28/APERTURA DE PROPOSICIONES  EA-913005999-N28-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  // /* {
  //   nombre: "ACTA APERTURA EA-913005999-N28-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N28/ACTA APERTURA EA-913005999-N28-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // }, */
  //  {
  //   nombre: "FALLO EA-913005999-N28-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N28/FALLO  EA-913005999-N28-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];
export const convocatoriaObra02 = [
  {
    nombre: "CONVOCATORIA 02-2026 OBRA",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 02-2026/CONVOCATORIA 02-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const lop4 = [
  {
    nombre: "BASES CAASIM-HGO-L.O.P.-04-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 02-2026/CAASIM-HGO-L.O.P.-04-2026/BASES CAASIM-HGO-L.O.P.-04-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-L.O.P.-04-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 02-2026/CAASIM-HGO-L.O.P.-04-2026/CATALOGO MUDO CAASIM-HGO-L.O.P.-04-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-04-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 02-2026/CAASIM-HGO-L.O.P.-04-2026/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-04-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-04-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 02-2026/CAASIM-HGO-L.O.P.-04-2026/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-04-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-04-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 02-2026/CAASIM-HGO-L.O.P.-04-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-04-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO CAASIM-HGO-L.O.P.-04-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 02-2026/CAASIM-HGO-L.O.P.-04-2026/FALLO CAASIM-HGO-L.O.P.-04-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const convocatoria008 = [
  {
    nombre: "CONVOCATORIA 08-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 08-2026/CONVOCATORIA 08-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n29 = [
  {
    nombre: "BASES EA-913005999-N29-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 08-2026/N29/BASES EA-913005999-N29-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N29-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 08-2026/N29/JUNTA DE ACLARACIONES EA-913005999-N29-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  // {
  //   nombre: "APERTURA DE PROPOSICIONES EA-913005999-N28-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N28/APERTURA DE PROPOSICIONES  EA-913005999-N28-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },

  {
    nombre: "ACTA APERTURA EA-913005999-N29-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 08-2026/N29/ACTA APERTURA EA-913005999-N29-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "FALLO EA-913005999-N29-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 08-2026/N29/FALLO EA-913005999-N29-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n30 = [
  {
    nombre: "BASES EA-913005999-N30-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 08-2026/N30/BASES EA-913005999-N30-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N30-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 08-2026/N30/JUNTA DE ACLARACIONES EA-913005999-N30-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  // {
  //   nombre: "APERTURA DE PROPOSICIONES EA-913005999-N28-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N28/APERTURA DE PROPOSICIONES  EA-913005999-N28-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },

  {
    nombre: "ACTA APERTURA EA-913005999-N30-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 08-2026/N30/ACTA APERTURA EA-913005999-N30-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N30-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 08-2026/N30/FALLO EA-913005999-N30-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n31 = [
  {
    nombre: "BASES EA-913005999-N31-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 08-2026/N31/BASES EA-913005999-N31-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N31-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 08-2026/N31/JUNTA DE ACLARACIONES EA-913005999-N31-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  // {
  //   nombre: "APERTURA DE PROPOSICIONES EA-913005999-N28-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N28/APERTURA DE PROPOSICIONES  EA-913005999-N28-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },

  {
    nombre: "ACTA APERTURA EA-913005999-N31-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 08-2026/N31/ACTA APERTURA EA-913005999-N31-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "FALLO EA-913005999-N31-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 08-2026/N31/FALLO EA-913005999-N31-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n32 = [
  {
    nombre: "BASES EA-913005999-N32-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 08-2026/N32/BASES EA-913005999-N32-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N32-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 08-2026/N32/JUNTA DE ACLARACIONES EA-913005999-N32-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  // {
  //   nombre: "APERTURA DE PROPOSICIONES EA-913005999-N28-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 07-2026/N28/APERTURA DE PROPOSICIONES  EA-913005999-N28-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },

  {
    nombre: "ACTA APERTURA EA-913005999-N32-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 08-2026/N32/ACTA APERTURA EA-913005999-N32-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "FALLO EA-913005999-N32-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 08-2026/N32/FALLO EA-913005999-N32-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const convocatoriaObra03 = [
  {
    nombre: "CONVOCATORIA 03-2026 OBRA",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 03-2026/CONVOCATORIA 03-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const lop5 = [
  {
    nombre: "BASES CAASIM-HGO-L.O.P.-05-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 03-2026/CAASIM-HGO-L.O.P.-05-2026/BASES CAASIM-HGO-L.O.P.-05-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-L.O.P.-05-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 03-2026/CAASIM-HGO-L.O.P.-05-2026/CATALOGO MUDO CAASIM-HGO-L.O.P.-05-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-05-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 03-2026/CAASIM-HGO-L.O.P.-05-2026/CROQUIS DE LOCALIZACION CAASIM-HGO-L.O.P.-05-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-05-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 03-2026/CAASIM-HGO-L.O.P.-05-2026/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-05-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-05-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 03-2026/CAASIM-HGO-L.O.P.-05-2026/PRESENTACION Y APERTURA DE PROPOSICIONES  CAASIM-HGO-L.O.P.-05-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // {
  //   nombre: "FALLO CAASIM-HGO-L.O.P.-04-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 02-2026/CAASIM-HGO-L.O.P.-04-2026/FALLO CAASIM-HGO-L.O.P.-04-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];
export const lop6 = [
  {
    nombre: "BASES CAASIM-HGO-L.O.P.-06-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 03-2026/CAASIM-HGO-L.O.P.-06-2026/BASES CAASIM-HGO-L.O.P.-06-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-L.O.P.-06-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 03-2026/CAASIM-HGO-L.O.P.-06-2026/CATALOGO MUDO CAASIM-HGO-L.O.P-06-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-06-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 03-2026/CAASIM-HGO-L.O.P.-06-2026/CROQUIS DE LOCALIZACION CAASIM-HGO-L.O.P.-06-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-06-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 03-2026/CAASIM-HGO-L.O.P.-06-2026/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-06-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-06-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 03-2026/CAASIM-HGO-L.O.P.-06-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-06-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // {
  //   nombre: "FALLO CAASIM-HGO-L.O.P.-04-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA OBRA 02-2026/CAASIM-HGO-L.O.P.-04-2026/FALLO CAASIM-HGO-L.O.P.-04-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];
